<template>
    <v-data-table v-bind="{ items, headers }" mobile-breakpoint="10000" disable-pagination disable-sort hide-default-footer class="v-sheet--outlined nshop-order-view-section fill-height">
        <template #top> <div class="table-label px-1 white">결제정보</div> </template>
        <template v-for="(header, index) in headers.filter((h) => h.hasOwnProperty('formatter'))" #[`item.${header.value}`]="{ value, item }"> <span :key="index" v-html="header.formatter.bind(item)(value, item)" /> </template>
    </v-data-table>
</template>

<script>
import { initDataTableHeaders } from "@/assets/lib";
import { NSHOP_ORDER_PAYMENT_METHODS, OPENBANK_PG_TEXTS } from "@/store/nshop";

export default {
    props: {
        order: { type: Object, default: () => ({}) },
    },
    computed: {
        items() {
            return [this.order];
        },
        method() {
            return this.order?.payment?.method;
        },
        headers() {
            const headers = [
                { text: "결제수단", value: "payment.method", formatter: (v) => NSHOP_ORDER_PAYMENT_METHODS[v]?.text || "-" },
                { text: "단가", value: "price.unit", formatterType: "number", formatterSuffix: "원" },
                { text: "결제금액", value: "price.sum", formatterType: "number", formatterSuffix: "원" },
                { text: "수수료", value: "price.fee", formatterType: "number", formatterSuffix: "원" },
                { text: "실결제금액", value: "price.sale", formatterType: "number", formatterSuffix: "원" },
                { text: "결제상태", value: "_payment", formatter: (v) => (v ? "결제완료" : "미결제") },
            ];

            switch (this.method) {
                case "vaccount": {
                    headers.push(
                        //
                        { text: "입금은행", value: "payment.vaccount.bankName" },
                        { text: "입금계좌", value: "payment.vaccount.number" },
                        { text: "입금금액", value: "payment.vaccount.amount", formatterType: "number", formatterSuffix: "원" },
                    );
                    break;
                }
                case "openbank": {
                    // 결제창은 쿠콘/이니시스를 번갈아 쓰므로 어느 PG로 결제됐는지부터 보여준다.
                    const pg = this.order?.payment?.openbank?.pg || "checkpay";

                    headers.push({ text: "결제사", value: "payment.openbank.pg", formatter: () => OPENBANK_PG_TEXTS[pg] || pg });

                    if (pg === "wpay") {
                        headers.push(
                            //
                            { text: "결제계좌", value: "payment.openbank.wpay.accountNo" },
                            { text: "회원키", value: "payment.openbank.wpay.wpayUserKey" },
                        );
                    } else {
                        headers.push(
                            //
                            { text: "결제계좌", value: "payment.openbank.checkpay.accountNo" },
                            { text: "회원코드", value: "payment.openbank.checkpay.membCd" },
                        );
                    }
                    break;
                }
            }

            return initDataTableHeaders(headers);
        },
    },
};
</script>
